/**
 * @abstract
 * */
export class Step {
    constructor(component) {
        if (this.constructor == Step) {
            throw new Error("Abstract classes can't be instantiated.");
        }

        this._component = component;

        this._title = null;
        this._content = null;

        this._button = null;
        this._fields_to_send = [];

        this._extra_data_to_send = {};

        this._send_request = null;

        this._before_mount = null;
        this._before_leave = null;

        this._api_endpoint = null;

        this._back_button_visible = true;
        this._back_button = null;
        this._last = false;

        this._guard = false;
        this._guard_reset_datas = [];

        this._parent_component = null;

        this._enter_animate_duration = .2;
        this._back_animate_duration = null;
        this._leave_animate_duration = .2;

        this._show_progress = true;

        this._progress_bar_text = false;
    }

    button(value) {
        this._button = value;
        return this;
    }

    hideProgress(){
        this._show_progress = false;
        return this;
    }

    animateDuration(duration){
        this._enter_animate_duration = duration;
        this._leave_animate_duration = duration;
        return this;
    }
    enterAnimateDuration(duration){
        this._enter_animate_duration = duration;
        return this;
    }
    backAnimateDuration(duration){
        this._back_animate_duration = duration;
        return this;
    }
    leaveAnimateDuration(duration){
        this._leave_animate_duration = duration;
        return this;
    }

    parentComponent(component){
        this._parent_component = component;
        return this;
    }

    guard(value){
        this._guard = true;
        this._guard_reset_datas = value;
        return this;
    }

    last() {
        this._last = true;
        return this;
    }

    backButton(value) {
        this._back_button = value;
        return this;
    }

    disableBackButton() {
        this._back_button_visible = false;
        return this;
    }

    backButtonVisible(value = true) {
        this._back_button_visible = value;
        return this;
    }

    apiEndpoint(value) {
        this._api_endpoint = value;
        return this;
    }

    title(value) {
        this._title = value;
        return this;
    }

    content(value) {
        this._content = value;
        return this;
    }

    addExtraDataToSend(value) {
        this._extra_data_to_send = {...this._extra_data_to_send, ...value};
        return this;
    }

    sendRequest(value) {
        this._send_request = value;
        return this;
    }

    beforeMount(value) {
        this._before_mount = value;
        return this;
    }

    beforeLeave(value) {
        this._before_leave = value;
        return this;
    }

    shouldSendRequest() {
        if (_.isNull(this._send_request)) {
            return !!(_.size(this._fields_to_send) + _.size(this._extra_data_to_send));
        }

        return this._send_request;
    }

    progressBarText(value) {
        this._progress_bar_text = value;
        return this;
    }
}
